import script from "./legoButtonExtend.vue?vue&type=script&lang=js"
export * from "./legoButtonExtend.vue?vue&type=script&lang=js"

import "./legoButtonExtend.vue?vue&type=style&index=0&id=c1446fb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1446fb8"],['__file',"src/components/lego/extend/legoButtonExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1446fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1446fb8', __exports__)) {
    api.reload('c1446fb8', __exports__)
  }
  
}


export default __exports__